<script lang="ts">
  import { browser } from '$app/environment';

  if (browser) {
    window.dataLayer = window.dataLayer || [];

    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', 'G-L6Y9XG6C5N');
  }
</script>
